import React, { useEffect } from 'react';
import Header from '../../../../header';
import Footer from '../../../../footer';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';
import atelierRed from '../../../../../assets/images/atelierRed.png';
import atelierWhite from '../../../../../assets/images/atelierWhite.png';
import competitionRed from '../../../../../assets/images/competitionRed.png';
import competitionWhite from '../../../../../assets/images/competitionWhite.png';
import spectatorRed from '../../../../../assets/images/spectatorRed.png';
import spectatorWhite from '../../../../../assets/images/spectatorWhite.png';
import { Link } from 'react-router-dom';
import { getLang } from '../../../../../environnement';

function EventFormItem({
  title,
  icon,
  iconHovered,
  link,
  details
}) {
  return (
    <Link to={link}>
      <div className={`group mx-14 mb-10 sm:mb-16 flex flex-col items-center ${details ? 'sm:h-96' : 'xxs:h-96'} cursor-pointer`}>
        <div className={`rounded-full border border-primary w-40 h-40 ${details ? 'sm:w-60 sm:h-60' : 'xxs:w-60 xxs:h-60'} flex justify-center items-center group-hover:bg-primary`}>
          <img src={icon} alt='itemIcon' className='group-hover:hidden w-24 h-24'/>
          <img src={iconHovered} alt='itemIcon' className='hidden group-hover:inline w-24 h-24'/>
        </div>
        <p className={`font-medium text-primary text-center mt-5 ${details ? 'text-sm sm:text-xl' : 'text-xl'}`}>{title}</p>
      </div>
    </Link>
  );
}

export default function InscriptionStudent() {
  const lang = useSelector(langSelector);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Header />
      <div className='flex flex-col items-center'>
        <p className={`text-primary mx-10 xxs:mx-0 text-center my-10 text-2xl sm:text-3xl font-medium`}>{getLang(lang).firstWorldCup.participerStudentEvent}</p>
        <div className='flex flex-col justify-center items-center pt-5 pb-10 lg:flex-row w-[90%]'>
          <EventFormItem icon={atelierRed} iconHovered={atelierWhite} title={getLang(lang).firstWorldCup.inscriptionStudentAttelier} link='https://forms.gle/Qn1Xnszntq7hp87w5' />
          <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
          <EventFormItem icon={competitionRed} iconHovered={competitionWhite} title={getLang(lang).firstWorldCup.inscriptionStudentCompetition} link='https://forms.gle/jedHcMxdqqn8M4HK8' />
          <span className='text-5xl text-primary font-medium lg:h-60 hidden lg:inline'>...</span>
          <EventFormItem icon={spectatorRed} iconHovered={spectatorWhite} title={getLang(lang).firstWorldCup.inscriptionStudentSpectateur} link='https://forms.gle/mqStMm7288EMLSrA8' />
        </div>
      </div>
      <Footer />
    </div>
  );
}
